import { createComponent } from '@carvana/merch-components';

export const ChevronWrapper = createComponent('div', {
  className: 'flex shrink-0 items-center'
});

export const LinkName = createComponent('div', {
  className: 'line-clamp-2 t-heading-sm'
});

export const Link = createComponent('a', {
  className:
    'group grid min-h-[72px] grid-cols-[1fr_32px] items-center gap-2xl text-text-strong hover:text-text-strong-hover'
});

export const UpperWrapper = createComponent('div', {
  className: 'flex flex-col items-start gap-sm overflow-hidden'
});

export const SubWrapper = createComponent('div', {
  className: 'flex items-center gap-md'
});

export const Copy = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
